export const bottomMenu = [
  {
    bottomMenuCap: "Developed with love by Hzaman",
    bottomMenuLink: "https://www.linkedin.com/in/hzaman-shohag/",
  },
];
